module.exports = {
  IN: 'https://tnc.dominos.co.in/',
  LK: 'https://tnc.dominoslk.com/',
  BG: 'https://tnc.dominos.com.bd/'
}